export default __webpack_public_path__ + "static/mars-atmosphere-9a06ab9fbf2c5cce17106c18944d1237.jpeg";